// extracted by mini-css-extract-plugin
export default {"checkout-success":"Success_checkout-success__lwcnn","checkout-success-announcement":"Success_checkout-success-announcement__8vsHy"};